import React from 'react';
import {View, Preloader, iSessionStorage} from '@ab/components';
import reactErrorTpl from '../templates/reactError';
import mainTpl from '../templates/main';
import Model from '../models/main.m';
import {bindActionCreators} from 'redux';
import actionCreators from '../../../actions';
import {set, get} from '../../../config';
import '../less/index.less';

const MIN_MOBILE = 0,
    MAX_MOBILE = 760, // 768 tablet S
    MIN_TABLET = 761,
    MAX_TABLET = 1270; // 1280 laptop S

export default class extends View {
    uiStates = {
        ...this.uiStates,
        REACT_ERROR: 'reactError',
    };

    templates = {
        [this.uiStates.INITIAL]: (
            <div className="module-app">
                <Preloader className="center" />
            </div>
        ),
        [this.uiStates.ERROR]: mainTpl,
        [this.uiStates.STANDBY]: (
            <div className="module-app">
                <Preloader className="center" />
            </div>
        ),
        [this.uiStates.INTERACTIVE]: mainTpl,
        [this.uiStates.REACT_ERROR]: reactErrorTpl,
    };

    constructor(props) {
        super(props);

        this.model = new Model();

        this.state = {
            // current UI states
            ui: this.uiStates.INITIAL,
            viewport: this._getViewportType(),
        };

        this.actions = bindActionCreators(actionCreators, this.props.dispatch);
    }

    async componentWillReady(resolve) {
        const model = this.getModel();
        try {
            await model.fetch();
            console.log(model);
            set({
                // API_BASE: model.get('baseUrl'),
                USER_PHONE: model.get('phone') || '',
                XREF: model.get('xref') || '',
                EMAIL: model.get('email') || '',
                FIO: model.get('fio') || '',
                FIRST_NAME: model.get('f_name') || '',
                SECOND_NAME: model.get('l_name') || '',
                PATRONYMIC: model.get('m_name') || '',
                TEACHER: true,
            });

            this.actions.lang('uk');

            resolve();
        } catch (error) {
            window.console.log(error);
            set({
                FIO: `${error.data?.client_data?.l_name} ${error.data?.client_data?.f_name} ${error.data?.client_data?.m_name}`,
                FIRST_NAME: error.data?.client_data?.f_name || '',
                SECOND_NAME: error.data?.client_data?.l_name || '',
                PATRONYMIC: error.data?.client_data?.m_name || '',
                TEACHER: true,
            });
            this.errorHandler(error);
        }
    }

    componentDidCatch(error, info) {
        this.setState({
            ui: this.uiStates.REACT_ERROR,
            error,
            info,
        });
    }

    commonProps() {
        return {
            ...this.props,
            viewport: this.state.viewport,
        };
    }

    logout() {
        this.actions.showLogout();
    }

    _hideLogout = () => {
        this.actions.hideLogout();
    };

    _logout = async () => {
        iSessionStorage.clear();

        try {
            await this.getModel().logout();
        } catch (error) {
            // no nee to handle
        }

        document.location.href = get('AUTHORIZATION_URL');
    };

    _handleWindowResize = () => {
        const viewport = this._getViewportType();

        if (viewport !== this.state.viewport) {
            this.setState({viewport});
        }
    };

    _getViewportType() {
        const width = window.screen.availWidth;

        if (width >= MIN_MOBILE && width <= MAX_MOBILE) {
            return this.viewportTypes.MOBILE;
        } else if (width >= MIN_TABLET && width <= MAX_TABLET) {
            return this.viewportTypes.TABLET;
        } else {
            return this.viewportTypes.DESKTOP;
        }
    }

    static displayName = 'Application';
}
